<mat-menu>
  @if (
    permissions()?.canAddRequestForRequestForQuotation || permissions()?.canAddRequestForRequestForQutoationFromTemplate
  ) {
    <div
      mat-menu-item
      disabled
    >
      Sourcing Events
    </div>
  }
  @if (permissions()?.canAddRequestForRequestForQuotation) {
    <button
      mat-menu-item
      matTooltip="New Request for Request for Quotation"
      (click)="addRequestForRfq()"
    >
      <procure-entity-badge
        class="badge"
        [label]="EntityIdAliasPrefixes.RfRFQ"
        [copyNumber]="false"
        [linked]="false"
      />
      New Sourcing Event
    </button>
  }
  @if (permissions()?.canAddRequestForRequestForQutoationFromTemplate) {
    <button
      mat-menu-item
      matTooltip="New Request for Request for Quotation from Template Request for RFQ"
      (click)="showTemplateFinder()"
    >
      <procure-entity-badge
        class="badge"
        [label]="EntityIdAliasPrefixes.TemplateRfrfq"
        [copyNumber]="false"
        [linked]="false"
      />
      New Sourcing Event from Template
    </button>
  }
  @if (permissions()?.canAddProject) {
    <div
      mat-menu-item
      disabled
    >
      Projects
    </div>
    <button
      mat-menu-item
      (click)="addProject()"
    >
      <procure-entity-badge
        class="badge"
        [label]="EntityIdAliasPrefixes.Project"
        [copyNumber]="false"
        [linked]="false"
      />
      New Project
    </button>
  }
</mat-menu>
